import { useState, useEffect, useContext, useRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect, Link } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from '../lib/formatter.ts';
import Http from 'services/http2';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import Download from 'components/download.js';
import * as MobileActions from 'actions/index.ts';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import EnumService from 'services/enum2';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import OrderService from 'services/order';
import CompanyService from 'services/company2';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import DialogProfitCenter from 'components/dialogProfitCenter';
import ModalService from 'services/modal';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import { withStyles } from '@material-ui/core/styles';
import MuiButton from '@material-ui/core/Button';
import Big from 'big.js';
import ESignService from 'services/esign';
import CommonFns from 'functions/common.ts';
import HeadCustField from 'components/headCustField';
import BodydCustField from 'components/bodyCustField';
// import Upload from 'components/upload.jsx';
/*
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=https%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fpurchase%2Forder%2Fdetail%2F91904378%2F1016329175467075&response_type=code&scope=snsapi_base&state=123#wechat_redirect

https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx69332f4727b14d05&redirect_uri=https%3A%2F%2Fconsole.xiekeyun.com%2Fmp%2Fsale%2Fcustomer%2Forder%2Fdetail%2F30252802%2F1015402800009858&response_type=code&scope=snsapi_base&state=123#wechat_redirect

https://console.xiekeyun.com/mp/sale/customer/order/detail/30252802/1015919737913493
*/
const styles = theme => ({
  paper: {
    margin: '10px',
    width: '90vw'
  }
});
function OrderDetail(props) {
  const Config = {
    sale: {
      title: '客户订单列表',
      apiPath: '/customerPurchase/detail',
      enumMainKey: 'B02_NCPo_Status',
      receiveStatusKey: 'B02_CPo_Delivery_Status',
      companyCodeKey: 'customerCode',
      companyNameKey: 'innerCustomerName',
      custFieldBillType: 10, //自定义字段单别
      arrEnumField: [
        {
          mainKey: 'B02_Purchase_Type',
          subKey: 'purchaseType',
          value: 'purchaseTypeName'
        },
        {
          mainKey: 'B02_NCPo_Status',
          subKey: 'orderStatus',
          value: 'orderStatusName'
        },
        {
          mainKey: 'B02_CPo_Delivery_Status',
          subKey: 'deliveryStatus',
          value: 'deliveryStatusName'
        }
      ],
      idField: 'poXkNo',
      custCompanyParamsCodes: ['Is_Required_Line_Confirmation'] //客户企业参数
    },
    purchase: {
      title: '采购订单列表',
      apiPath: '/purchase/detail',
      enumMainKey: 'B02_NPo_Status',
      receiveStatusKey: 'B02_Po_Receive_Status',
      companyCodeKey: 'companyCode',
      companyNameKey: 'innerVendorName',
      custFieldBillType: 10, //自定义字段单别
      arrEnumField: [
        {
          mainKey: 'B02_Purchase_Type',
          subKey: 'purchaseType',
          value: 'purchaseTypeName'
        },
        {
          mainKey: 'B02_NPo_Status',
          subKey: 'orderStatus',
          value: 'orderStatusName'
        },
        {
          mainKey: 'B02_Po_Receive_Status',
          subKey: 'receiveStatus',
          value: 'receiveStatusName'
        }
      ],
      idField: 'poXkNo',
      wfmCode: '1013'
    }
  };

  const { state, dispatch } = useContext(ActionContext);
  const config = Config[props.type];
  config.dispatch = dispatch;
  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    moreSign1,
    moreSign2,
    handleMore,
    decimalPlace,
    fileList,
    setShowLoading,
    setFileList,
    setRedirect,
    detail,
    setDetail,
    workflow,
    fieldSetting,
    isOpenOrgFlag,
    self
  } = useDetail(props, config);

  const [canConfirm, setCanConfirm] = useState(false);
  const [canResponse, setCanResponse] = useState(false);
  const [profitCenterList, setProfitCenterList] = useState([]);
  const [storehouseList, setStorehouseList] = useState([]);
  const [receiveAreaType, setReceiveAreaType] = useState(undefined);
  const [paramValue, setParamValue] = useState(undefined);
  const [openProfitCenter, setOpenProfitCenter] = useState(false);
  const [isReplyPrice, setIsReplyPrice] = useState(false);
  const [currItem, setCurrItem] = useState({});
  const [currReply, setCurrReply] = useState({
    vExpectedDate: '',
    vPurchaseQty: '',
    vTaxPrice: 0,
    vPrice: 0,
    isContainTax: '',
    vRemark: ''
  });
  const [operateType, setOperateType] = useState(1);
  const [showReply, setShowReply] = useState(false);
  const [canSend, setCanSend] = useState(false);
  const [custCompanyParams, setCustCompanyParams] = useState({});
  const [detailField, setDetailField] = useState([]);
  const skipPriceCheckRef = useRef(false);

  // const [queueLimit, setQueueLimit] = useState(1);

  // const [fileObj, setFileObj] = useState({
  //   fileType: 'file',
  //   queueLimit: 5,
  //   oft: 4,
  //   totalMaxFileSize: 50,
  //   maxFileSize: 50
  // });

  //处理详情数据
  self.afterGetDetail = function (data) {
    if (self.isPurchase) {
      //多角订单收货方不确认答交
      setCanConfirm(
        [null, undefined, 0, 2].includes(data.multiRelationSourceType)
      );
      data.status = data.orderStatus; //补充审批流单据状态

      setCanSend(
        data.orderStatus === 14 &&
          (data.sourceSystem === 2 ||
            ([1, 5].includes(data.sourceSystem) && data.syncStatus === 2))
      );
      getGroupMinPrice(data);
      userPreferenceDetail();
    } else {
      //获取客户企业参数
      CompanyService.getCompanyParamsByCodes(
        data.customerCode,
        config.custCompanyParamsCodes,
        false
      ).then(res => {
        let objParams = {};
        res.forEach(row => {
          objParams[row.paramCode] =
            row.paramType === 1 ? row.paramValue : row.paramValue === '1';
        });
        setCustCompanyParams(objParams);
      });
      //多角订单账款方不答交客户订单
      setCanResponse(
        [null, undefined, 0, 2].includes(data.multiRelationSourceType)
      );
      setIsReplyPrice(data.answerPricePermission === '1' ? true : false);
    }

    //重新组装答交信息，便于模板显示
    if (data.answer) {
      //有答交信息
      let replyList = data.answer.lineList;
      data.lineList.forEach(item => {
        let arr = [];
        replyList.forEach(reply => {
          if (reply.lineNo === item.lineNo) {
            if (typeof reply.diffReason === 'string') {
              reply.diffReason = reply.diffReason.split(','); //B02_Answer_Diff  1单价差异，2数量差异，3交期差异
            } else {
              reply.diffReason = [];
            }
            arr.push(reply);
          }
        });
        item.replyList = arr;

        //操作类型  1:同意; 2:确认
        if (
          Array.isArray(item.replyList) &&
          item.replyList.some(reply => reply.isAgreeDiff)
        ) {
          setOperateType(2);
        }
      });
    }

    if (!self.isPurchase) {
      //答交页
      let arrAnswerLineNo = [];
      if (data.answer) {
        //已答交
        arrAnswerLineNo = data.answer.lineList.map(item => item.lineNo);
      }
      data.lineList.forEach(item => {
        if (arrAnswerLineNo.indexOf(item.lineNo) === -1) {
          //未达交过项次（新订单或变更后新增）
          let obj = { subLineNo: 1 };
          Util.copyPropsBySchema(obj, item, [
            'lineNo',
            'productCode',
            ['purchaseQty', 'vPurchaseQty'],
            ['expectedDate', 'vExpectedDate'],
            item.isContainTax ? ['taxPrice', 'vTaxPrice'] : ['price', 'vPrice'],
            item.isContainTax
              ? ['taxLineAmount', 'vTaxLineAmount']
              : ['lineAmount', 'vLineAmount']
          ]);
          item.replyList = [obj];
        } else if (data.answerPricePermission !== '1') {
          //如果采购方设置了不答交单价，需要根据订单价格刷新答交价格，以防止退回的订单无法保存。
          item.replyList.forEach(reply => {
            reply.vTaxPrice = item.taxPrice;
            reply.vPrice = item.price;
            reply.vLineAmount =
              reply.vPrice *
              reply.vPurchaseQty *
              (item.valuationQty / item.purchaseQty);
            reply.vTaxLineAmount =
              reply.vTaxPrice *
              reply.vPurchaseQty *
              (item.valuationQty / item.purchaseQty);
          });
        }
      });
    }
    Util.genExtendFields(data);
    //单身枚举
    data.lineList.forEach((item, i) => {
      Util.genExtendFields(item);
      EnumService.getValue('B02_Pol_Status', item.status).then(value => {
        item.statusName = value;
        if (i === data.lineList.length - 1) {
          setDetail(data);
        }
      });
    });
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);

    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  //获取用户偏好
  function userPreferenceDetail() {
    let postbody = {
      objCode: companyCode,
      objType: 2,
      contentType: '10',
      apiPath: '/userSetting/userPreferenceDetail'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success && response.data) {
        let res = Util.jsonDecode(response.data.contentJson) || {};
        if (!Util.isEmpty(res.mobileDetailField)) {
          let mobileDetailField = res.mobileDetailField
            .filter(row => row.disabled || row.hide !== true)
            .map(row => row.component);
          setDetailField(mobileDetailField);
        }
      }
    });
  }

  //获取最低价格
  function getGroupMinPrice(data) {
    if (Util.isEmpty(data.lineList)) {
      return;
    }
    let postbody = {
      poXkNo: self.id,
      companyCode: companyCode,
      apiPath: '/purchase/getStatsPrice'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let arrData = response.data;
        if (!Util.isEmpty(arrData)) {
          data.lineList.forEach(item => {
            arrData.some(row => {
              if (row.productCode === item.productCode) {
                item.minPrice = row.minPrice;
                item.minTaxPrice = row.minTaxPrice;
                item.latestPurchasePrice = row.latestPurchasePrice; //最近未税采购价
                item.latestPurchaseTaxPrice = row.latestPurchaseTaxPrice; //最近含税采购价
              }
              return row.productCode === item.productCode;
            });
          });
          setDetail(data);
        }
      }
    });
  }

  /** 采购方操作 begin **/

  //同意
  async function handleConsent() {
    let postbody = getPostbody();
    postbody.operateType = operateType; //操作类型  1:同意; 2:确认
    OrderService.consentOrderReply(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //退回
  async function handleReject() {
    let postbody = getPostbody();
    OrderService.rejectOrderReply(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //发布
  async function publish() {
    if (detail.sourceSystem !== 2 && !detail.formTypeCode) {
      ModalService.showError('单别不能为空', dispatch);
      return;
    }

    //发布时校验
    const isValid = await validatePublish();
    if (!isValid) {
      return;
    }

    let postbody = {
      companyCode: companyCode,
      poXkNo: self.id
    };
    OrderService.publishOrder(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //发布时校验
  async function validatePublish() {
    if ([0, 11, 14].includes(detail.orderStatus)) {
      if (skipPriceCheckRef.current) {
        skipPriceCheckRef.current = false;
        return true;
      }

      // 获取企业参数
      let companyParams = {};
      await CompanyService.getCompanyParamsByCodes(
        companyCode,
        ['PO_Publish_Price_Check_Mode'],
        false
      ).then(res => {
        res.forEach(row => {
          companyParams[row.paramCode] =
            row.paramType === 1 ? row.paramValue : row.paramValue === '1';
        });
      });

      let mode = String(companyParams['PO_Publish_Price_Check_Mode'] || '');
      if (mode === '2') {
        return true;
      }

      let postbody = {
        companyCode: companyCode,
        poXkNo: detail.poXkNo,
        apiPath: '/purchase/checkValidatePricing'
      };
      let response = await Http.post('/api/cloudCenter', postbody);
      if (response.success) {
        return true;
      }
      if (response.errorCode === 'Dynamic_PurchaseOrder_ERR_0147') {
        if (mode === '1') {
          let ok = () => {
            updatePricing();
          };
          ModalService.showConfirm(response.errorMsg, ok, dispatch);
          return false;
        }
        if (mode === '3') {
          let doUpdate = () => {
            updatePricing();
          };
          let doNoUpdate = () => {
            skipPriceCheckRef.current = true;
            // 判断是否需要发布订单：
            // （开启审批 且 applyCheckFlag == 1）或（未开启审批）→ 发布订单
            // 否则忽略，需对方手动送审
            let approvalEnabled = workflow.isActive;
            let applyCheckFlag = detail.applyCheckFlag;
            if ((approvalEnabled && applyCheckFlag === 1) || !approvalEnabled) {
              publish();
            } else if (approvalEnabled && applyCheckFlag !== 1) {
              // 开了审批流但不需要自动发布，重新拉起送审弹框
              dispatch({ type: 'showWfConfirm', actionId: detail.id });
            }
          };
          let doCancel = () => {
            // 取消，退出当前弹框，不发布订单
          };
          ModalService.showThreeConfirm(
            response.errorMsg,
            doUpdate,
            doNoUpdate,
            doCancel,
            '操作提示',
            '更新',
            '不更新',
            '取消',
            dispatch
          );
          return false;
        }
      }

      ModalService.showError(response.errorMsg, dispatch);
      return false;
    }
  }

  // 更新有效核价价格
  async function updatePricing() {
    let postbody = {
      apiPath: '/purchase/updatePricing',
      companyCode: companyCode,
      poXkNo: self.id
    };
    let response = await Http.post('/api/cloudCenter?btnId=013', postbody);
    if (response.success) {
      ModalService.showTip('更新成功', dispatch);
      self.getDetail();
      return true;
    } else {
      ModalService.showError(response.errorMsg, dispatch);
      return false;
    }
  }

  //已答交状态下，可撤回
  function recall() {
    let postbody = {
      companyCode,
      poXkNo: self.id
    };
    OrderService.purchaseRecall(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //发送
  function send() {
    let postbody = getPostbody();
    OrderService.sendOrder(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  /** 采购方操作 end **/

  //客户订单确认
  async function orderConfirm() {
    let openEsign;
    await ESignService.checkOpenFlag(
      companyCode,
      detail.customerXkUniqueCode,
      '1',
      false,
      detail.customerCode
    ).then(rs => {
      openEsign = rs.isOpen && rs.isAuto && !rs.isAlowMobile;
    });
    if (openEsign) {
      ModalService.showError(
        '客户已开启自动签章，请到PC端订单详情确认',
        dispatch
      );
      return;
    }

    OrderService.customerOrderConfirm(
      [self.id],
      response => {
        if (response.success) {
          self.getDetail();
        }
      },
      dispatch
    );
  }

  //订单出货
  async function handleDelivery() {
    let storehouseListCopy = [];
    ModalService.showLoading(dispatch);
    let errormsg;

    let openDirectErrorMsg;
    //供应商档案直运控制参数是否开启
    await CompanyService.getCustomerDetail(
      companyCode,
      detail.customerXkUniqueCode
    ).then(rs => {
      openDirectErrorMsg =
        rs.directDeliveryFlag === 1 ? '客户开启仅允许按照直运计划送货' : ''; //是否限定按直运看板送货：0:不启用 1:启用
    });
    if (openDirectErrorMsg) {
      ModalService.hideLoading(dispatch);
      ModalService.showError(openDirectErrorMsg, dispatch);
      return;
    }

    // 供应商是否按仓库送货
    await CompanyService.getDeliveryInfo(detail).then(data => {
      setParamValue(data.paramValue);
      setStorehouseList(data.storehouseList || []);
      storehouseListCopy = data.storehouseList || [];
      setReceiveAreaType(data.receiveAreaType);
      errormsg = data.errormsg;
    });

    if (errormsg) {
      ModalService.hideLoading(dispatch);
      ModalService.showError(errormsg, dispatch);
      return;
    }

    //检查是否开启利润中心
    CompanyService.checkOpenProfit(detail.customerCode).then(res => {
      ModalService.hideLoading(dispatch);
      if (res === true) {
        //已开启
        ModalService.showLoading(dispatch);
        let opts = {
          poXkNo: detail.poXkNo,
          purchaseType: detail.purchaseType,
          receiveCompanyCode: detail.receiveCompanyCode
        };
        CompanyService.getProfitCenter(
          companyCode,
          detail.customerXkUniqueCode,
          false,
          true,
          opts
        ).then(rs => {
          ModalService.hideLoading(dispatch);
          if (Array.isArray(rs)) {
            setProfitCenterList(rs);
            if (rs.length) {
              popProfitCenter();
            } else {
              //没有收货部门也允许新建送货
              customerOrderDelivery({}, storehouseListCopy);
            }
          } else {
            //失败时也允许新建送货
            customerOrderDelivery({}, storehouseListCopy);
          }
        });
      } else {
        //未开启
        customerOrderDelivery({}, storehouseListCopy);
      }
    });
  }

  //弹窗选择收货部门
  function popProfitCenter() {
    setOpenProfitCenter(true);
  }

  //客户订单转送货通知
  function customerOrderDelivery(data = {}, storehouseListCopy = []) {
    if (detail.purchaseType === 7 || storehouseListCopy.length > 0) {
      popProfitCenter();
    } else {
      let postbody = {
        ...data,
        receiveAreaType,
        companyCode,
        poXkNo: self.id,
        apiPath: '/customerPurchase/convertDeliveryNotice'
      };
      Http.post('/api/cloudCenter?btnId=001', postbody).then(response => {
        if (response.success) {
          if (response.data.canNotDeliveryMsg) {
            ModalService.showTip(response.data.canNotDeliveryMsg, dispatch);
          } else {
            ModalService.showTip('新建成功', dispatch);
            setTimeout(() => {
              setRedirect(
                '/mp/sale/delivery/detail/' +
                  companyCode +
                  '/' +
                  response.data.dnXkNo
              );
            }, 2000);
          }
        } else if (response.errorMsg) {
          ModalService.showError(response.errorMsg, dispatch);
        }
      });
    }
  }

  //编辑答交信息
  // type 1,编辑  2,删除  3,新增
  function handleEdit(reply, type, item) {
    reply.isContainTax = item.isContainTax;
    reply.purchaseUnitName = item.purchaseUnitName;
    reply.vExpectedDateShow =
      formatDate(reply.vExpectedDate, 'YYYY-MM-DD') || '';
    if (type === 1) {
      for (const key in reply) {
        if (
          Object.hasOwnProperty.call(reply, key) &&
          [
            'vExpectedDate',
            'vPurchaseQty',
            'vTaxPrice',
            'vPrice',
            'isContainTax',
            'vRemark'
          ].includes(key)
        ) {
          reply[key] = reply[key] || '';
          if (key === 'vTaxPrice' || key === 'vPrice') {
            reply[key] = reply[key] || 0;
          }
        }
      }
    } else if (type === 3) {
      reply = { subLineNo: 0 };
      let n = Big(0); //答交总数量
      item.replyList.forEach(row => {
        if (row.subLineNo > reply.subLineNo) {
          reply = Object.assign({}, row);
        }
        if (Util.isBig(row.vPurchaseQty)) {
          n = n.plus(row.vPurchaseQty);
        }
      });
      //自动根据数量差额填写
      reply.vPurchaseQty = n.gte(item.purchaseQty) ? 0 : item.purchaseQty - n;
      reply.vLineAmount =
        reply.vPrice *
        reply.vPurchaseQty *
        (item.valuationQty / item.purchaseQty);
      reply.vTaxLineAmount =
        reply.vTaxPrice *
        reply.vPurchaseQty *
        (item.valuationQty / item.purchaseQty);
      reply.subLineNo += 1;
      delete reply.id;
    }
    setCurrItem(item);
    setCurrReply(reply);
    setShowReply(true);
    setOperateType(type);
  }

  function handleDateChange(event) {
    let detailObj = Util.clone(currReply);
    if (event.target.value) {
      detailObj.vExpectedDate = event.target.valueAsNumber - 28800000;
      detailObj.vExpectedDateShow =
        formatDate(detailObj.vExpectedDate, 'YYYY-MM-DD') || '';
    }
    setCurrReply(detailObj);
  }

  function handleChange(event, key) {
    let detailObj = Util.clone(currReply);
    let val = event.target.value;
    if (['vPurchaseQty', 'vTaxPrice', 'vPrice'].includes(key)) {
      val = Util.qtyChange(val);
    }
    detailObj[key] = val;
    setCurrReply(detailObj);
  }

  function handleClose() {
    setShowReply(false);
  }

  function handleOk() {
    let lineList = [];
    currItem.replyList.forEach(reply => {
      reply.productName = currItem.productName;
      if (reply.id !== currReply.id) {
        lineList.push(reply);
      } else {
        lineList.push(currReply);
      }
    });
    if (operateType === 2) {
      let index = currItem.replyList.findIndex(
        item => item.id === currReply.id
      );
      let currItemObj = Util.clone(currItem);
      currItemObj.replyList.splice(index, 1);
      lineList = currItemObj.replyList;
    }
    if (operateType === 3) {
      lineList.push(currReply);
    }

    lineList.forEach(item => {
      if (!Util.isEmpty(item.diffReason) && Array.isArray(item.diffReason)) {
        item.diffReason = item.diffReason.join(',');
      }
    });
    let postbody = {
      lineNo: currItem.lineNo,
      lineList: lineList,
      poXkNo: self.id,
      companyCode: companyCode,
      apiPath: '/customerPurchase/answerByLineNo'
    };
    Http.post('/api/cloudCenter?btnId=001', postbody).then(response => {
      if (response.success) {
        ModalService.showTip('保存成功', dispatch);
        handleClose();
        self.getDetail();
        setCurrReply({
          vExpectedDate: '',
          vPurchaseQty: '',
          vTaxPrice: 0,
          vPrice: 0,
          isContainTax: '',
          vRemark: ''
        });
      } else if (response.errorMsg) {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  //是否需要供应商逐行确认
  function updateConfirmStatus(item) {
    if (!custCompanyParams['Is_Required_Line_Confirmation']) {
      return;
    }
    let ok = function () {
      let postbody = {
        companyCode: companyCode,
        poXkNo: self.id,
        lineNo: item.lineNo,
        apiPath: '/customerPurchase/updateConfirmStatus'
      };
      ModalService.showLoading(dispatch);
      Http.post('/api/cloudCenter?btnId=009', postbody).then(response => {
        ModalService.hideLoading(dispatch);
        if (response.success) {
          ModalService.showTip('操作成功', dispatch);
          item.confirmStatus = 1;
          self.getDetail();
        } else {
          ModalService.showError(response.errorMsg, dispatch);
        }
      });
    };
    ModalService.showConfirm(
      '是否确认项次' + item.poLineNoShow + '？',
      ok,
      dispatch
    );
  }

  //获取提交参数
  function getPostbody() {
    let postbody = {
      poXkNoList: [{ poXkNo: detail.poXkNo, companyCode: companyCode }]
    };
    return postbody;
  }

  function showFileList(businessType, obj) {
    const { actions } = props;
    let businessKey =
        businessType === 9 ? obj.poXkNo + '_' + obj.lineNo : obj.poXkNo,
      xkNo = obj.poXkNo,
      lineNo = obj.lineNo,
      cCode = obj[config.companyCodeKey];
    setShowLoading(true);
    CompanyService.getFileList(
      businessType,
      businessKey,
      xkNo,
      lineNo,
      cCode
    ).then(res => {
      setShowLoading(false);
      if (Array.isArray(res)) {
        let arr = res.map(item => {
          return { ...item };
        });
        setFileList(arr);
      }
    });
    actions.openDownloadModal();
  }

  function showUpload() {
    dispatch({ type: 'showUpload' });
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  //路由跳转
  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  let noDiff = (
    <p>
      <i className="icon-success"></i> 答交无差异
    </p>
  );

  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>基础信息</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label">采购日期</span>
                  <div className="field-value">
                    {formatDate(detail.erpPurchaseDate)}
                  </div>
                </li>
                <li>
                  <span className="field-label">订单状态</span>
                  <div>
                    <span
                      className={
                        'u-sign ' +
                        CommonFns.getStatusClass(
                          self.isPurchase
                            ? 'B02_NPo_Status'
                            : 'B02_NCPo_Status',
                          detail.orderStatus
                        )
                      }
                    >
                      {detail.orderStatusName}
                    </span>
                  </div>
                </li>
                <li>
                  <span className="field-label">送货状态</span>
                  {self.isPurchase ? (
                    <div
                      className={
                        detail.receiveStatus === 0
                          ? 'order-detail-value orange'
                          : 'order-detail-value green'
                      }
                    >
                      {detail.receiveStatusName}
                    </div>
                  ) : (
                    <div
                      className={
                        detail.deliveryStatus === 0
                          ? 'order-detail-value orange'
                          : 'order-detail-value green'
                      }
                    >
                      {detail.deliveryStatusName}
                    </div>
                  )}
                </li>
                {/* 审批流状态 仅开启后才显示 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批环节</span>
                    <div className="field-value">
                      <WorkflowStatus
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                      />
                    </div>
                  </li>
                )}
                {/* 审批流按钮 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批操作</span>
                    <div className="field-value">
                      <WorkflowButtons
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                        onChange={() => {
                          self.getDetail();
                        }}
                        onComplete={() => {
                          self.getDetail();
                        }}
                        applyValidate={validatePublish}
                      />
                    </div>
                  </li>
                )}
                <li>
                  <span className="field-label">
                    {self.isPurchase ? '采购方' : '客户'}
                  </span>
                  <div className="field-value">
                    {self.isPurchase
                      ? self.companyInfo.companyName
                      : detail.innerCustomerName}
                  </div>
                </li>
                <li>
                  <span className="field-label">供应商</span>
                  <div className="field-value">{detail.innerVendorName}</div>
                </li>
                <li>
                  <span className="field-label">采购订单</span>
                  <div className="field-value">{detail.poErpNo}</div>
                </li>
                <li>
                  <span className="field-label">平台单号</span>
                  <div className="field-value">{detail.poXkNo}</div>
                </li>
                <li>
                  <span className="field-label">采购类型</span>
                  <div className="field-value">{detail.purchaseTypeName}</div>
                </li>
                <li>
                  <span className="field-label">ERP单别</span>
                  <div className="field-value">{detail.formTypeName}</div>
                </li>
                <li>
                  <span className="field-label">交易条件</span>
                  <div className="field-value">{detail.conditionName}</div>
                </li>
                <li>
                  <span className="field-label">交易币别</span>
                  <div className="field-value">{detail.currencyName}</div>
                </li>
                <li>
                  <span className="field-label">采购员</span>
                  <div className="field-value">{detail.buyerName}</div>
                </li>
                <li>
                  <span className="field-label">交易税别</span>
                  <div className="field-value">{detail.taxName}</div>
                </li>
                <li>
                  <span className="field-label">付款条件</span>
                  <div className="field-value">
                    {detail.payWayCode}-{detail.payWayName}
                  </div>
                </li>
                {(isOpenOrgFlag ||
                  [2, 3, 4].includes(detail.sourceType) ||
                  detail.sourceSystem === 2) && (
                  <li>
                    <span className="field-label">采购组织</span>
                    <div className="field-value">
                      {detail.erpOrgCode}-{detail.erpOrgName}
                    </div>
                  </li>
                )}

                {/* 采购说明 */}
                {detail.extendFields &&
                  detail.extendFields.map((row, i) => (
                    <li key={'extendFields' + i}>
                      <span className="field-label">{row.key}</span>
                      <div className="field-value">{row.value}</div>
                    </li>
                  ))}

                {detail.attachCount > 0 &&
                  (!self.isPurchase ||
                    User.checkAuth('10010112') ||
                    User.checkAuth('10010107')) && (
                    <li>
                      <span className="field-label">订单附件</span>
                      <div className="field-value">
                        <span
                          className="attachment"
                          onClick={() => showFileList(61, detail)}
                        >
                          {detail.attachCount}个附件
                          <i className="icon-attachment"></i>
                        </span>
                      </div>
                    </li>
                  )}
              </ul>
            </div>
          </div>

          {/* <div
            className={moreSign1 ? 'm-more' : 'm-more m-more-open'}
            onClick={() => {
              handleMore(1);
            }}
          >
            {moreSign1 && '更多'}
            {!moreSign1 && '收起'}
            <i className="icon-down"></i>
          </div> */}
        </div>

        <div className="m-details-item">
          {/* 单头自定义 */}
          <HeadCustField
            fieldSetting={fieldSetting}
            detail={detail}
            setDetail={setDetail}
            isPurchase={self.isPurchase}
          ></HeadCustField>
        </div>

        {detail.purchaseType === 3 && (
          <div className="m-details-item">
            <div className="details-item-title">
              <label>多角订单信息</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                {self.isPurchase &&
                  detail.multiRelationSourceType === 2 &&
                  detail.multiPur && (
                    <ul className="field-list">
                      <li>
                        <span className="field-label">来源企业</span>
                        <div className="field-value">
                          {detail.multiPur.sourceCustomerInnerName}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">来源单号</span>
                        <div className="field-value">
                          {detail.multiPur.sourcePoErpNo}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">收货企业</span>
                        <div className="field-value">
                          {detail.multiPur.receiveCustomerInnerName}
                        </div>
                      </li>
                    </ul>
                  )}
                {self.isPurchase &&
                  detail.multiRelationSourceType === 1 &&
                  detail.multiRec && (
                    <ul className="field-list">
                      <li>
                        <span className="field-label">外部供应商</span>
                        <div className="field-value">
                          {detail.multiRec.deliveryVendorInnerName}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">外发订单号</span>
                        <div className="field-value">
                          {detail.multiRec.deliveryVendorInnerCode}
                        </div>
                      </li>
                    </ul>
                  )}
                {!self.isPurchase &&
                  detail.multiRelationSourceType === 2 &&
                  detail.multiVendor && (
                    <ul className="field-list">
                      <li>
                        <span className="field-label">收货企业</span>
                        <div className="field-value">
                          {detail.multiVendor.receiveCustomerInnerName}
                        </div>
                      </li>
                    </ul>
                  )}
                {!self.isPurchase &&
                  detail.multiRelationSourceType === 1 &&
                  detail.multiPur && (
                    <ul className="field-list">
                      <li>
                        <span className="field-label">外部供应商</span>
                        <div className="field-value">
                          {detail.multiPur.deliveryVendorInnerName}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">外发订单号</span>
                        <div className="field-value">
                          {detail.multiPur.outsidePoErpNo}
                        </div>
                      </li>
                    </ul>
                  )}
              </div>
            </div>
          </div>
        )}

        <div className="m-details-item">
          <div className="details-item-title">
            <label>条款、备注、物流信息等</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label">附件上传</span>
                  <div className="field-value">
                    <span
                      className="link"
                      onClick={() => {
                        showUpload();
                      }}
                    >
                      上传
                    </span>
                  </div>
                </li>
                <li>
                  <span className="field-label">订单备注</span>
                  <div className="field-value">{detail.remark}</div>
                </li>
                <li>
                  <span className="field-label">补充条款</span>
                  <div className="field-value">{detail.agreement}</div>
                </li>
                <li>
                  <span className="field-label">物流方式</span>
                  <div className="field-value">{detail.logisticsName}</div>
                </li>
                <li>
                  <span className="field-label">收货地址</span>
                  <div className="field-value">{detail.addressInfo}</div>
                </li>
              </ul>
            </div>
          </div>
          {/* <div
            className={moreSign2 ? 'm-more' : 'm-more m-more-open'}
            onClick={() => {
              handleMore(2);
            }}
          >
            {moreSign2 && '更多'}
            {!moreSign2 && '收起'}
            <i className="icon-down"></i>
          </div> */}
        </div>

        <div className="m-details-item">
          <div className="details-item-title">
            <label>产品明细</label>
          </div>
          <div className="details-item-content">
            {detail.lineList?.map((item, index) => (
              <div className="content-line line-list-item" key={index}>
                <div className="line-list-item-title">
                  <span>项次{item.poLineNoShow}</span>
                  {!self.isPurchase &&
                    canResponse &&
                    User.checkAuth('20010102') &&
                    [1, 3, 10].includes(detail.orderStatus) && (
                      <div className="more">
                        {custCompanyParams['Is_Required_Line_Confirmation'] &&
                          item.confirmStatus !== 1 && (
                            <i
                              className="icon-success"
                              onClick={() => updateConfirmStatus(item)}
                            ></i>
                          )}
                        {custCompanyParams['Is_Required_Line_Confirmation'] &&
                          item.confirmStatus === 1 && (
                            <span className="green">已确认</span>
                          )}
                        <i
                          className="icon-edit"
                          onClick={() => handleEdit({}, 3, item)}
                        ></i>
                      </div>
                    )}
                </div>

                <ul className="field-list">
                  {(Util.isEmpty(detailField) ||
                    detailField.includes('productCode')) && (
                    <li>
                      <span className="field-label">产品编码</span>
                      <div className="field-value">{item.productCode}</div>
                    </li>
                  )}
                  {(Util.isEmpty(detailField) ||
                    detailField.includes('productName')) && (
                    <li>
                      <span className="field-label">产品名称</span>
                      <div className="field-value">{item.productName}</div>
                    </li>
                  )}
                  {(Util.isEmpty(detailField) ||
                    detailField.includes('productScale')) && (
                    <li>
                      <span className="field-label">产品规格</span>
                      <div className="field-value">{item.productScale}</div>
                    </li>
                  )}
                  {(Util.isEmpty(detailField) ||
                    detailField.includes('brandName')) && (
                    <li>
                      <span className="field-label">品牌</span>
                      <div className="field-value">{item.brandName}</div>
                    </li>
                  )}
                  {(Util.isEmpty(detailField) ||
                    detailField.includes('profitCenterName')) && (
                    <li>
                      <span className="field-label">收货部门</span>
                      <div className="field-value">
                        {item.profitCenterCode
                          ? item.profitCenterCode + ' '
                          : ''}
                        {item.profitCenterName ? item.profitCenterName : ''}
                      </div>
                    </li>
                  )}
                  {(Util.isEmpty(detailField) ||
                    detailField.includes('taxPrice')) && (
                    <li>
                      <span className="field-label">采购单价</span>
                      <div className="field-value">
                        {detail.isContainTax === 1
                          ? formatNumber(
                              item.taxPrice,
                              decimalPlace.Price_Decimal_Place
                            )
                          : formatNumber(
                              item.price,
                              decimalPlace.Price_Decimal_Place
                            )}
                      </div>
                    </li>
                  )}
                  {(Util.isEmpty(detailField) ||
                    detailField.includes('taxLineAmount')) && (
                    <li>
                      <span className="field-label">采购金额</span>
                      <div className="field-value">
                        <span className="blue">
                          {detail.isContainTax === 1
                            ? formatNumber(
                                item.taxLineAmount,
                                decimalPlace.Amount_Decimal_Place
                              )
                            : formatNumber(
                                item.lineAmount,
                                decimalPlace.Amount_Decimal_Place
                              )}
                        </span>
                      </div>
                    </li>
                  )}
                  {(Util.isEmpty(detailField) ||
                    detailField.includes('expectedDate')) && (
                    <li>
                      <span className="field-label">交货时间</span>
                      <div className="field-value">
                        {formatDate(item.expectedDate)}
                      </div>
                    </li>
                  )}
                  {(Util.isEmpty(detailField) ||
                    detailField.includes('purchaseQty')) && (
                    <li>
                      <span className="field-label">采购数量</span>
                      <div className="field-value">
                        {formatNumber(
                          item.purchaseQty,
                          decimalPlace.Quantity_Decimal_Place
                        )}{' '}
                        {item.purchaseUnitName}
                      </div>
                    </li>
                  )}
                  {(self.isPurchase && Util.isEmpty(detailField)) ||
                    (detailField.includes('latestPurchaseTaxPrice') && (
                      <li>
                        <span className="field-label">最近采购单价</span>
                        <div className="field-value">
                          {detail.isContainTax === 1
                            ? formatNumber(
                                item.latestPurchaseTaxPrice,
                                decimalPlace.Price_Decimal_Place
                              )
                            : formatNumber(
                                item.latestPurchasePrice,
                                decimalPlace.Price_Decimal_Place
                              )}
                        </div>
                      </li>
                    ))}
                  {(Util.isEmpty(detailField) ||
                    detailField.includes('statusName')) && (
                    <li>
                      <span className="field-label">单身状态</span>
                      <div className="field-value">{item.statusName}</div>
                    </li>
                  )}
                  {(Util.isEmpty(detailField) ||
                    detailField.includes('valuationQty')) && (
                    <li>
                      <span className="field-label">计价数量</span>
                      <div className="field-value">
                        {formatNumber(
                          item.valuationQty,
                          decimalPlace.Quantity_Decimal_Place
                        )}{' '}
                        {item.valuationUnitName}
                      </div>
                    </li>
                  )}
                  {item.attachCount > 0 &&
                    (((User.checkAuth('10010112') ||
                      User.checkAuth('10010107')) &&
                      Util.isEmpty(detailField)) ||
                      detailField.includes('attachment')) && (
                      <li>
                        <span className="field-label">附件</span>
                        <div className="field-value">
                          <span
                            className="attachment"
                            onClick={() => showFileList(9, item)}
                          >
                            {item.attachCount}个附件
                            <i className="icon-attachment"></i>
                          </span>
                        </div>
                      </li>
                    )}
                  {item.remark &&
                    (Util.isEmpty(detailField) ||
                      detailField.includes('remark')) && (
                      <li className="single">
                        <span className="field-label">备注</span>
                        <div className="field-value">{item.remark}</div>
                      </li>
                    )}
                  {item.printExtendFields !== '' &&
                    (Util.isEmpty(detailField) ||
                      detailField.includes('extendFields')) && (
                      <li className="single">
                        <span className="field-label">采购说明</span>
                        <div className="field-value">
                          {item.printExtendFields}
                        </div>
                      </li>
                    )}
                </ul>
                {/* 单身自定义字段 */}
                {(Util.isEmpty(detailField) ||
                  detailField.includes('itemsCustomField')) && (
                  <BodydCustField
                    fieldSetting={fieldSetting}
                    line={item}
                    isPurchase={self.isPurchase}
                  ></BodydCustField>
                )}
                <div
                  className={
                    (!self.isPurchase && !item.replyList) ||
                    (self.isPurchase && detail.orderStatus === 1)
                      ? 'order-detail-more hide'
                      : 'order-detail-more'
                  }
                >
                  {(!item.replyList ||
                    (item.replyList.length === 1 &&
                      item.replyList[0].vStatus !== 2)) &&
                    noDiff}
                  {item.replyList &&
                    item.replyList.map((reply, i) => (
                      <div
                        className="content-line line-list-item"
                        key={String(reply.id) + i + 1}
                      >
                        {!self.isPurchase &&
                          canResponse &&
                          User.checkAuth('20010102') &&
                          [1, 3, 10].includes(detail.orderStatus) && (
                            <div className="line-list-item-title">
                              <span>交期{i + 1}</span>
                              <div className="more">
                                <i
                                  className="icon-edit"
                                  onClick={() => handleEdit(reply, 1, item)}
                                ></i>
                                {!self.isPurchase && (
                                  <i
                                    className="icon-delete"
                                    onClick={() => handleEdit(reply, 2, item)}
                                  ></i>
                                )}
                              </div>
                            </div>
                          )}

                        <ul className="field-list">
                          <li
                            className={
                              reply.diffReason?.indexOf('3') > -1 ? 'red' : ''
                            }
                          >
                            <span className="field-label">答交时间</span>
                            <div className="field-value">
                              {formatDate(reply.vExpectedDate)}
                            </div>
                          </li>
                          <li
                            className={
                              reply.diffReason?.indexOf('2') > -1 ? 'red' : ''
                            }
                          >
                            <span className="field-label">答交数量</span>
                            <div className="field-value">
                              {formatNumber(
                                reply.vPurchaseQty,
                                decimalPlace.Quantity_Decimal_Place
                              )}{' '}
                              {item.purchaseUnitName}
                            </div>
                          </li>
                          <li
                            className={
                              reply.diffReason?.indexOf('1') > -1 ? 'red' : ''
                            }
                          >
                            <span className="field-label">答交单价</span>
                            <div className="field-value">
                              {item.isContainTax === 1
                                ? formatNumber(
                                    reply.vTaxPrice,
                                    decimalPlace.Price_Decimal_Place
                                  )
                                : formatNumber(
                                    reply.vPrice,
                                    decimalPlace.Price_Decimal_Place
                                  )}
                            </div>
                          </li>
                          <li
                            className={
                              reply.diffReason?.indexOf('1') > -1 ? 'red' : ''
                            }
                          >
                            <span className="field-label">备注</span>
                            <div className="field-value">{reply.vRemark}</div>
                          </li>
                        </ul>
                      </div>
                    ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="m-details-item account">
          <div className="details-item-title">
            <label>合计</label>
          </div>
          <div className="details-item-content">
            <div className="content-line line-list-item">
              <ul className="field-list">
                <li>
                  <label className="field-label">订单数量</label>
                  <div className="field-value">
                    <span className="blue">
                      {formatNumber(
                        detail.totalCount,
                        decimalPlace.Quantity_Decimal_Place
                      )}
                    </span>
                  </div>
                </li>
                <li>
                  <label className="field-label">订单金额</label>
                  <div className="field-value">
                    <span className="blue">
                      {detail.isContainTax
                        ? formatNumber(
                            detail.productTaxTotal,
                            decimalPlace.Amount_Decimal_Place
                          )
                        : formatNumber(
                            detail.productTotal,
                            decimalPlace.Amount_Decimal_Place
                          )}
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        open={showReply}
        onClose={() => handleClose()}
        classes={{ paper: props.classes.paper }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {operateType === 1
            ? '编辑答交信息'
            : operateType === 2
              ? '删除答交信息'
              : '新增答交信息'}
        </DialogTitle>
        <DialogContent>
          <ul>
            <li className="dialog order-detail-item">
              <div className="line">
                <span>项次：</span>
                <div>{currReply.lineNo}</div>
              </div>
              <div className="line">
                <span>物料编码：</span>
                <div>{currReply.productCode}</div>
              </div>
              <div className="line">
                <span>答交时间：</span>
                <div>
                  {[1, 3].includes(operateType) ? (
                    <form noValidate>
                      <TextField
                        value={currReply.vExpectedDateShow || ''}
                        onChange={e => handleDateChange(e)}
                        id="date"
                        type="date"
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </form>
                  ) : (
                    <span>{formatDate(currReply.vExpectedDate)}</span>
                  )}
                </div>
              </div>
              <div className="line">
                <span>答交数量：</span>
                <div>
                  {[1, 3].includes(operateType) ? (
                    <input
                      type="text"
                      value={currReply.vPurchaseQty}
                      onChange={e => handleChange(e, 'vPurchaseQty')}
                    />
                  ) : (
                    <span>
                      {formatNumber(
                        currReply.vPurchaseQty,
                        decimalPlace.Quantity_Decimal_Place
                      )}{' '}
                      {currReply.purchaseUnitName}
                    </span>
                  )}
                </div>
              </div>
              <div className="line">
                <span>答交单价：</span>
                <div>
                  {isReplyPrice && [1, 3].includes(operateType) ? (
                    <input
                      type="text"
                      value={
                        currReply.isContainTax
                          ? currReply.vTaxPrice
                          : currReply.vPrice
                      }
                      onChange={e =>
                        handleChange(
                          e,
                          currReply.isContainTax ? 'vTaxPrice' : 'vPrice'
                        )
                      }
                    />
                  ) : (
                    <span>
                      {currReply.isContainTax === 1
                        ? formatNumber(
                            currReply.vTaxPrice,
                            decimalPlace.Price_Decimal_Place
                          )
                        : formatNumber(
                            currReply.vPrice,
                            decimalPlace.Price_Decimal_Place
                          )}
                    </span>
                  )}
                </div>
              </div>
              <div className="line">
                <span>备注：</span>
                <div>
                  {[1, 3].includes(operateType) ? (
                    <input
                      type="text"
                      value={currReply.vRemark}
                      onChange={e => handleChange(e, 'vRemark')}
                    />
                  ) : (
                    <span>{currReply.vRemark}</span>
                  )}
                </div>
              </div>
            </li>
          </ul>
        </DialogContent>
        <DialogActions>
          <MuiButton onClick={() => handleClose()} color="primary">
            取消
          </MuiButton>
          {[1, 3].includes(operateType) && (
            <MuiButton onClick={() => handleOk()} color="primary">
              确定
            </MuiButton>
          )}
          {operateType === 2 && (
            <MuiButton onClick={() => handleOk()} color="secondary">
              确认删除
            </MuiButton>
          )}
        </DialogActions>
      </Dialog>
      {self.isPurchase ? (
        <div className="wrap m-flex-box fixed-bottom">
          {/* 发布（审批流程）*/}
          {User.checkAuth('10010111') &&
            workflow.data?.purchase_publish_1?.complete &&
            detail.replyAction !== false && (
              <Button
                type="default"
                onClick={() => {
                  publish();
                }}
                className={
                  [0, 11].includes(detail.orderStatus)
                    ? 'm-flex-item u-btn u-btn_primary'
                    : 'hide'
                }
              >
                发布
              </Button>
            )}
          {/* 退回 */}
          {User.checkAuth('10010103') &&
            detail.publishStatus === 1 &&
            canConfirm &&
            detail.orderStatus === 2 &&
            detail.replyAction !== false && (
              <Button
                type="default"
                onClick={() => {
                  handleReject();
                }}
                className="m-flex-item u-btn u-btn_warn"
              >
                退回
              </Button>
            )}
          {/* 撤回 */}
          {User.checkAuth('10010114') &&
            detail.publishStatus !== 0 &&
            [1, 2, 3, 5].includes(detail.orderStatus) &&
            [1, 5].includes(detail.sourceSystem) &&
            [0, 3].includes(detail.syncStatus) &&
            detail.replyAction !== false && (
              <Button
                type="default"
                onClick={() => {
                  recall();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                撤回
              </Button>
            )}
          {/* 确认/同意 */}
          {User.checkAuth('10010103') &&
            canConfirm &&
            detail.orderStatus === 2 &&
            workflow.data?.purchase_answer_1?.complete &&
            detail.replyAction !== false && (
              <Button
                type="default"
                onClick={() => {
                  handleConsent();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                {operateType === 1 ? '确认' : '同意'}
              </Button>
            )}
        </div>
      ) : (
        ''
      )}

      {self.isPurchase &&
      workflow.data?.purchase_publish_1?.complete &&
      canSend &&
      detail.replyAction !== false &&
      User.checkAuth('10010108') ? (
        <div className="wrap m-flex-box fixed-bottom">
          <Button
            type="default"
            onClick={() => {
              send();
            }}
            className={
              detail.publishStatus === 0 && detail.orderStatus === 14
                ? 'm-flex-item u-btn u-btn_primary'
                : 'hide'
            }
          >
            发送 {canSend}
          </Button>
        </div>
      ) : (
        ''
      )}
      {/* 客户订单操作 */}
      {!self.isPurchase &&
        User.checkAuth('20010102') &&
        canResponse &&
        detail.replyAction !== false && (
          <div className="btn-container btn-fixed-container">
            <div className="left-wrap">
              <Link to="/mp/sale/customer/order/list">
                <i className="icon-left"></i>
                返回
              </Link>
            </div>
            <div className="right-wrap">
              {/* 新建送货 */}
              {detail.orderStatus === 5 &&
                [0, 1, null].indexOf(detail.deliveryStatus) !== -1 &&
                ((detail.sourceSystem === 1 && detail.syncStatus === 2) ||
                  [2, 5].includes(detail.sourceSystem)) &&
                ((detail.sourceType === 5 &&
                  (detail.compCustomer?.mroTemporaryFlag === 0 ||
                    (detail.compCustomer?.mroTemporaryFlag === 1 &&
                      detail.payStatus === 2))) ||
                  detail.sourceType !== 5) && (
                  <button
                    onClick={() => {
                      handleDelivery();
                    }}
                    className="btn"
                  >
                    新建送货
                  </button>
                )}
              {/* 订单确认 */}
              {detail.orderStatus === 1 && (
                <button
                  onClick={() => {
                    orderConfirm();
                  }}
                  className="btn btn-big"
                >
                  订单确认
                </button>
              )}
            </div>
          </div>
        )}
      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
      <Modal></Modal>
      <DialogProfitCenter
        currItem={detail}
        orgCompanyCode={companyCode}
        profitCenterList={profitCenterList}
        storehouseList={storehouseList}
        paramValue={paramValue}
        open={openProfitCenter}
        onComplete={data => {
          customerOrderDelivery(data);
        }}
        onClose={() => setOpenProfitCenter(false)}
      ></DialogProfitCenter>
    </div>
  );
}

OrderDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(OrderDetail));
